// libs/frontend/feature-public/src/lib/services/barra-navegacion.service.ts

import { Injectable, inject } from '@angular/core';
import { HttpService } from '@front/frontend/data-access-auth/services/http.service';
import { StrapiCollectionResponse, StrapiSubComponentesNavegadorEntry } from '@front/shared/data-access-cms';
import { Observable, map } from 'rxjs';

/** OpenAPI: StrapiSubComponentesNavegadorEntry; id puede venir en la respuesta */
export type ItemNavegacion = StrapiSubComponentesNavegadorEntry & { id?: number };

export interface BarraNavegacion {
  id: number;
  documentId: string;
  Componetizacion: ItemNavegacion[];
  comportamiento?: 'fixed' | 'observer';
  seccionesObservadas?: string;
  PaginaPrincipal?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BarraNavegacionService {
  private httpService = inject(HttpService);

  getPrimeraBarraNavegacion(parametros: { pageSize: number, locale: string }): Observable<BarraNavegacion | null> {
    return this.httpService.get<StrapiCollectionResponse<BarraNavegacion>>(
      `barra-de-navegacions?populate=Componetizacion&pagination[pageSize]=${parametros.pageSize}&locale=${parametros.locale}`
    ).pipe(
      map(response => response.data && response.data.length > 0 ? response.data[0] : null)
    );
  }
}
